import * as Sentry from "@sentry/react";
// Google Anayltics
import ReactGA from "react-ga";

const LogCapture = () => {
    const info = (
        message,
        category = "unknown",
        action = "unknown",
        value = 0
    ) => {
        Sentry.captureMessage(message, "info");
        const eventValue = !isNaN(value) ? value : 0;
        ReactGA.event({
            category,
            action,
            eventValue,
        });
    };

    const error = (message) => {
        Sentry.captureMessage(message, "error");
        ReactGA.exception({
            description: message,
            fatal: false,
        });
    };

    return { info, error };
};

export default LogCapture();
